import React from "react";
import { Navigate } from "react-router-dom";

function ProtectedRoute({ children }) {
  // Token localStorage se lo
  const token = localStorage.getItem("access_token");

  // Agar token missing ya empty hai → login page par redirect
  if (!token || token.trim() === "") {
    return <Navigate to="/admin-login" replace />;
  }

  // Agar token present hai → protected page show karo
  return children;
}

export default ProtectedRoute;